import React, { useContext } from "react";
import { Helmet } from "react-helmet";
import { ConfigContext } from "../../AppConfigProvider.js";
import { isDev } from "../../../config/env.js";
import { isClient } from "../../../helpers/utils.js";

export const HtmlGA4: React.FC = () => {
    const { googleAnalytics4Id } = useContext(ConfigContext);
    if (!googleAnalytics4Id) return null;

    if (isClient()) {
        window.dataLayer = window.dataLayer || [];
        window.gtag = function () {
            window.dataLayer.push(arguments);
        };
        gtag("consent", "default", {
            ad_storage: "denied",
            ad_user_data: "denied",
            ad_personalization: "denied",
            analytics_storage: "denied",
        });
        gtag("js", new Date());
        gtag("config", googleAnalytics4Id, {
            send_page_view: false,
            debug_mode: isDev,
        });
    }

    return (
        <Helmet>
            <script
                async
                src={`https://www.googletagmanager.com/gtag/js?id=${googleAnalytics4Id}`}
            />
        </Helmet>
    );
};

export default HtmlGA4;
